import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './GridBox.css';
import GridContext from '../GridContext';
import { classnames } from '../../../../helpers/classnames';

// A GridBox uses GridContext to determine real position from grid coordinates
// It is responsible for style box container
const GridBox = React.forwardRef((
  {
    children,
    x,
    y,
    width = 1,
    height = 1,
    margin = 0,
    style,
    onClick,
    className,
    isNestedInDuplicable = false,
  },
  ref,
) => {
  const grid = useContext(GridContext);
  const { columnWidth, rowHeight, gutter } = grid;

  const finalStyle = useMemo(
    () => {
      // If item is nested in a duplicate block we adjust it's size :
      // 10 is for 8px of margin + 2px of border (from DuplicateBlockWrapper)
      const adjust = isNestedInDuplicable ? 10 : 0;
      return {
        ...style,
        left: `${x * columnWidth + gutter + margin}px`,
        top: `${y * rowHeight + gutter + margin}px`,
        width: width * columnWidth - (gutter * 2 + margin * 2) - adjust,
        height: height * rowHeight - adjust,
      };
    },
    [x, y, width, height, rowHeight, columnWidth, style, gutter, margin, isNestedInDuplicable],
  );

  if (columnWidth === 0) {
    return null;
  }

  return (
    <div
      className={classnames([styles.GridBox, className])}
      style={finalStyle}
      onClick={onClick}
      ref={ref}
    >
      {children}
    </div>
  );
});

GridBox.displayName = 'GridBox';

GridBox.propTypes = {
  children: PropTypes.node,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  margin: PropTypes.number,
  style: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
  isNestedInDuplicable: PropTypes.bool,
};

export default GridBox;
